import { Avatar as AvatarBase } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
  src: string;
  alt?: string;
  size?: "small" | "medium" | "large";
  fallback?: ReactNode;
};

export const Avatar = ({ alt, size = "medium", src, fallback }: Props) => {
  const sizeInPixels = size === "small" ? 16 : size === "medium" ? 24 : 32;

  return (
    <AvatarBase
      alt={alt}
      src={src}
      sx={{
        width: sizeInPixels,
        height: sizeInPixels,
        fontSize: sizeInPixels * 0.75,
      }}
    >
      {fallback}
    </AvatarBase>
  );
};
